import { Box, Flex } from "@familyzone/component-library";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import { FormatExpiryTimeText } from "./InviteCodeHelpers";

interface InviteCodeContentProps {
	enabled: boolean;
	inviteCode: string;
	inviteCodeExpiry?: string;
	isLoading: boolean;
	onRegenerate: () => void;
	currentTimestampSource: () => number;
}

export const InviteCodeContent: FC<InviteCodeContentProps> = ({
	enabled,
	inviteCode,
	inviteCodeExpiry,
	isLoading,
	onRegenerate,
	currentTimestampSource,
}) => {
	const [expiryTimeText, setExpiryTimeText] = useState<string>("");

	const updateExpiry = () => {
		if (inviteCodeExpiry !== undefined) {
			const expiryNumber = parseInt(inviteCodeExpiry);
			setExpiryTimeText(FormatExpiryTimeText(currentTimestampSource(), expiryNumber));
		}
	};

	useEffect(() => {
		updateExpiry();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inviteCodeExpiry, currentTimestampSource]);

	useEffect(() => {
		const interval = setInterval(() => {
			updateExpiry();
		}, 1000);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inviteCodeExpiry, currentTimestampSource]);

	if (!enabled) {
		return <></>;
	}

	return (
		<>
			<Flex alignItems="end">
				<Box className="InviteCode_code">{inviteCode ? inviteCode : "----"}</Box>
				{isLoading ? (
					<Box pb="10px">
						<i className="fa fa-refresh fa-spin fa-fw InviteCode_codeRegenerate" data-testid="inviteCodeLoadingIcon" />
					</Box>
				) : (
					<Box pb="10px" onClick={onRegenerate} cursor="pointer">
						<i className="fa fa-recycle InviteCode_codeRegenerate" data-testid="inviteCodeRegenerateIcon" />
					</Box>
				)}
			</Flex>
			<Box>
				<Flex>Code Expires in:</Flex>
				<Flex>{expiryTimeText}</Flex>
			</Box>
		</>
	);
};
